// extracted by mini-css-extract-plugin
export var box = "CloseButton-module--box--665dc";
export var box_md = "CloseButton-module--box_md--388b7";
export var box_xmd = "CloseButton-module--box_xmd--44d5d";
export var box_flex = "CloseButton-module--box_flex--a16eb";
export var box_lg = "CloseButton-module--box_lg--e19f6";
export var box_sm = "CloseButton-module--box_sm--70fc8";
export var box_outer = "CloseButton-module--box_outer--10bd3";
export var box_whiteBg = "CloseButton-module--box_white-bg--25560";
export var box_noMarginBottom = "CloseButton-module--box_no-margin-bottom--b48bd";
export var box_noPadding = "CloseButton-module--box_no-padding--3a1eb";
export var box_outerGray = "CloseButton-module--box_outer-gray--0ae67";
export var box_dark = "CloseButton-module--box_dark--809b4";
export var box_zIndex = "CloseButton-module--box_z-index--4d26a";
export var box_zIndex6 = "CloseButton-module--box_z-index-6--2565b";
export var box_eventsWithLine = "CloseButton-module--box_events-with-line--28d8e";
export var box_featuresAo = "CloseButton-module--box_features-ao--4f699";
export var box_verticalPaddings = "CloseButton-module--box_vertical-paddings--068a2";
export var clearP = "CloseButton-module--clearP--6291a";
export var clearP_vc = "CloseButton-module--clearP_vc--cc91e";
export var close = "CloseButton-module--close--7edf9";
export var light = "CloseButton-module--light--97ae0";
export var closeIcon = "CloseButton-module--closeIcon--acdd6";
export var sm = "CloseButton-module--sm--84b2a";
export var fadeInAnimation = "CloseButton-module--fadeInAnimation--049fd";
export var placeHolderShimmer = "CloseButton-module--placeHolderShimmer--01079";